import React, { Component } from "react";
import { observer } from "mobx-react";
import { QuizObjectList } from "../../../../../../store/modquiz/quiz_objects/quiz-object";
import { placeCaretAtEnd } from "../../../../../../utils/ui";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import Input from "@mui/material/Input";
import ListItem from "./ListItem";

interface QuizObjectListComponentProps {
    list: QuizObjectList;
    showHelp: Function;
    hideHelp: Function;
}

interface OrderListWrapperProps {
    children: any;
    ordered: boolean;
}

function OrderedListWrapper({ children, ordered }: OrderListWrapperProps) {
    if (ordered) {
        return <ol className="editable-list list-group">{children}</ol>;
    } else {
        return <ul className="editable-list list-group">{children}</ul>;
    }
}

class QuizObjectListComponent extends Component<
    QuizObjectListComponentProps,
    any
> {
    list: any;
    listRef: Array<any> = [];
    nameRef: any;

    constructor(props: any) {
        super(props);

        this.state = {
            counter: 0,
            addedRow: false
        };

        this.nameRef = React.createRef();

        this.changeName = this.changeName.bind(this);
        this.addListItem = this.addListItem.bind(this);
        this.removeListItem = this.removeListItem.bind(this);
        this.saveContent = this.saveContent.bind(this);
        this.removeList = this.removeList.bind(this);
        this.restoreList = this.restoreList.bind(this);
    }

    componentDidUpdate() {
        if (this.state.addedRow) {
            this.listRef[this.listRef.length - 1].focus();
            this.setState({
                addedRow: false
            });
        }
    }

    componentDidMount() {
        if (this.listRef.length > 0) {
            if (this.props.list.name == "") {
                this.nameRef.focus();
            } else {
                this.listRef[this.listRef.length - 1].focus();
            }
        }
    }

    addListItem() {
        this.setState({
            addedRow: true
        });
        this.props.list.addRow();
    }

    removeListItem(i: number) {
        this.listRef[i - 1].focus();
        placeCaretAtEnd(this.listRef[i - 1]);
        this.props.list.removeRow(i);
    }

    changeName(ev: any) {
        this.props.list.setName(ev.currentTarget.value);
    }

    saveContent(i: number, ev: any) {
        this.props.list.saveListItem(i, ev.currentTarget.innerText);
    }

    removeList(ev: any) {
        this.props.list.remove();
    }

    restoreList(ev: any) {
        this.props.list.restore();
    }

    render() {
        var component = this;

        if (this.props.list.deleted) {
            return (
                <Button variant="contained" onClick={this.restoreList}>
                    Undo
                </Button>
            );
        }
        return (
            <div className="list-container">
                <FormGroup>
                    <Input
                        id="name"
                        onChange={this.changeName}
                        value={this.props.list.name}
                        className="underline title-field"
                        placeholder="List Name"
                        inputRef={(input) => { this.nameRef = input; }} 
                    />
                </FormGroup>
                <OrderedListWrapper ordered={this.props.list.ordered}>
                    {this.props.list.list.map((listItem: string, i: number) => {
                        this.listRef[i] = React.createRef();
                        return (
                            <ListItem
                                deleteListItem={component.removeListItem}
                                addListItem={component.addListItem}
                                saveContent={component.saveContent}
                                listItemText={listItem}
                                i={i}
                                key={i}
                                ref={c => {
                                    this.listRef[i] = c;
                                }}
                            />
                        );
                    })}
                </OrderedListWrapper>
                <Box className="list-toolbar" marginTop={2}>
                    <Button color="primary" onClick={this.addListItem}>
                        + Row
                    </Button>
                    <Button
                        color="primary"
                        onClick={this.props.list.toggleOrdered}
                    >
                        {this.props.list.ordered ? "Ordered" : "Unordered"}
                    </Button>
                    <Button color="secondary" onClick={this.removeList}>
                        Delete
                    </Button>
                    <Box
                        component="span"
                        color={
                            this.props.list.status == "error"
                                ? "secondary"
                                : "primary"
                        }
                    >
                        {this.props.list.status}
                    </Box>
                </Box>
            </div>
        );
    }
}

const ObservedQuizObjectListComponent = observer(QuizObjectListComponent);
export { ObservedQuizObjectListComponent as QuizObjectListComponent, OrderedListWrapper };
